<script>
	import { createEventDispatcher } from 'svelte';
    import { FileTextIcon, PhoneIcon, CalendarIcon } from 'svelte-feather-icons';
    import Carousel from './carousel.svelte';

	const dispatch = createEventDispatcher();

	const goToForm = () => {
		dispatch('go', 'form');
	}

    const services = [
        { service: "College option exploration", sub: "Comprehensive lists hand-tailored to your student" },
        { service: "Academic record analysis" },
        { service: "Student profile reviews", sub: "" }, //sub: "Athletic, Extracurricular and Volunteer Activities"
        { service: "Scholarship strategies", sub: "Academic, athletic, needs-based and private" },
        { service: "Standardized testing plans" },
        { service: "Entrance essay review", sub: "" },
        { service: "College tour advice", sub: "Where, when, and why" },
        { service: "Wait-list and deferral strategies", sub: "" },
        { service: "Final choice guidance", sub: "" },
    ]
    const thirds = [services.slice(0,3), services.slice(3, 6), services.slice(6, 9)];

    const today = new Date();
    const copyright = `${today.getFullYear() > 2021 ? `2021-${today.getFullYear()}` : `2021`} Tom Kulick and College Guidance Services of Texas.`;

</script>

<header class='bg-white pa3 ph4-ns ph5-l ph5-xl tc tl-ns flex-ns items-center justify-between'>
    <h1 class='f3 ma0 pa0 garamond ttu tracked fw4 black-70'>Tom Kulick</h1>
    <h2 class='f5 f4-ns ma0 pa0 garamond ttu tracked fw4 dn'>College Guidance Services of Texas</h2>
</header>
<div class='pv5 ph5 ph6-l ph6-xl tc'>
    <p class='f4 f2-ns ma0 pa0 mb4 garamond ttu tracked mt2-ns o-80'>College Guidance Services of Texas</p>
        <div class='dn'>
            <Carousel withQuotes />
        </div>
        <a href="#workwithtom" class='dib link lato bg-near-black br2 mt4 mb2-ns f5 ttu tracked bn pa3 white f4 dim hover pointer'>Work with Tom</a>
</div>
<div class='pa4 pv5 pa5-ns ph6-l ph6-xl bg-white tc'>
    <h3 class='garamond ttu tracked fw4 f3 ma0 pa0 bb bw1 b--black-05 pb1 dib'>Services Offered</h3>
    <div class='flex-ns items-start mt5'>
        {#each thirds as t}
    <ul class='w-100 w-third-ns list ma0 pa0 ph3-ns tl'>
        {#each t as s}
            <li class='pa3 ba b--black-10 mb3 lato'>
                <p class='ma0 pa0 f4 fw4 mb1'>{s.service}</p>
                {#if s.sub && s.sub.length}
                    <span class='f6 black-60'>{s.sub}</span>
                {/if}
            </li>
        {/each}
    </ul>
    {/each}
    </div>
</div>
<div class='pa5 ph6-l ph6-xl tc' id="workwithtom">
    <h3 class='garamond ttu tracked fw4 f3 ma0 pa0 bb bw1 b--black-05 pb1 dib'>Work with Tom</h3>
    <div class='mt5 flex-ns items-start justify-around center'>
        <div class='pa3 f4 lato w-100 w-30-ns mb5 mb0-ns'>
            <FileTextIcon size="48" strokeWidth="1" class='db center mb4 mb5-ns o-60' />
            <p>Fill out the college information worksheet.</p>
            <p class='f5 black-60 lh-copy'><button on:click={goToForm} class='blue dim hover bg-transparent bn pa0 ma0 pointer'>Click here to begin.</button></p>
        </div>
        <div class='pa3 f4 lato w-100 w-30-ns mb5 mb0-ns'>
            <PhoneIcon size="48" strokeWidth="1"  class='db center mb4 mb5-ns o-60' />
            <p>Schedule a complimentary 30-minute call.</p>
            <p class='f5 black-60 lh-copy'>Tom will reach out to check your availability. Parents and students will have a chance to ask any questions about the process.</p>
        </div>
        <div class='pa3 f4 lato w-100 w-30-ns'>
            <CalendarIcon size="48" strokeWidth="1"  class='db center mb4 mb5-ns o-60' />
            <p>Personalized college guidance begins.</p>
            <p class='f5 black-60 lh-copy'>Once all paperwork is signed, Tom will start working one-on-one with your student within <span class='fw8'>10 days</span>.</p>
        </div>
    </div>
</div>
<div class='pa4 pv5 pa5-ns ph6-l ph6-xl bg-white tc'>
    <h3 class='garamond ttu tracked fw4 f3 ma0 pa0 bb bw1 b--black-05 pb1 dib'>About Tom</h3>
    <div class='flex-ns items-start mt5'>
        <div class='w-100 w-50-ns pr5-ns tl'>
            <p class='lato ma0 pa0 lh-copy'>Mr. Kulick has been involved in the college search and planning process since 1977. He has earned degrees from Holy Cross College (A.B.), Brown University (M.A.) and Rhode Island College (M.Ed.). He has worked in international schools (Iranzamin-Tehran International School ) in Tehran, Iran and Escuela Bella Vista in Maracaibo. Venezuela. He has also worked in a public high School (Enosburg Falls High School) in Vermont and at a private secondary level school in Houston.</p><p class='lato lh-copy'>He has an academic background in International Relations and Comparative Politics. He has held memberships in NACAC (National Association of College Admissions Counselors) and TACAC (Texas Association of College Admissions Counselors). He has attended numerous professional national conferences sponsored by NACAC. </p>
        </div>
        <div class='w-100 w-50-ns pl5-ns tl'>
            <p class='lato ma0 pa0 lh-copy'>Tom has worked with thousands of students from a wide range of backgrounds. He has lived overseas and provided college guidance services to students from more than forty different countries. Over the past forty-four years he has visited more than one hundred and thirty colleges and universities in the United States as well as Ireland and Scotland.</p>
            <p class='lato lh-copy'> Tom has been happily married for over 34 years and is the proud father of two adult children. He retired in May of 2021 after thirty-nine years as a College Counselor at Strake Jesuit College Preparatory.</p>
        </div>
    </div>
</div>
<footer class='tc bt b--black-05 pa2'>
    <p class='f6 lato lh-copy'>&copy; {copyright}</p>
</footer>